import styled from "styled-components";
import { ModalContentWrapper } from "../../../ASRCard.styles";

export const Wrapper = styled(ModalContentWrapper)`
  text-align: center;
  align-items: center;
`;

export const BasicText = styled.div`
  font-weight: 400;
  font-size: 16px;
  color: var(--cvna-color-grey-5);
`;

export const BoldText = styled(BasicText)`
  font-weight: 700;
  color: var(--cvna-color-blue-6);
`;

export const TextBox = styled(BasicText)`
  white-space: pre-line;
  overflow-x: hidden;
  text-align: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex: 1;
  width: 100%;
`;